// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27%23FFFFFF%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27%23374151%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tf-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

/*
  Invisible honeypot field. Rendered next to every SubmitButton.
  Real users can't see, focus, or tab to it. Bots that crawl the DOM
  fill every input and trip the silent reject in useContactForm.
*/
.tf-honeypot {
  position: absolute !important;
  left: -10000px !important;
  top: auto !important;
  width: 1px !important;
  height: 1px !important;
  overflow: hidden !important;
  opacity: 0 !important;
  pointer-events: none !important;
  border: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
}

.tf-form__row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

@media (max-width: 600px) {
  .tf-form__row { grid-template-columns: 1fr; }
}

.tf-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.tf-field__label {
  font-size: 13px;
  font-weight: 500;
  line-height: 1.3;
  color: inherit;
}

.tf-field__required {
  color: var(--technum-teal, #00a896);
  margin-left: 2px;
}

.tf-field__input {
  width: 100%;
  border-radius: 6px;
  padding: 10px 14px;
  font-family: inherit;
  font-size: var(--body-regular, 14px);
  line-height: 1.4;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  appearance: none;
  box-sizing: border-box;
}

.tf-field__input--select {
  cursor: pointer;
  padding-right: 36px;
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 12px;
}

.tf-field__input--textarea {
  resize: vertical;
  min-height: 88px;
}

.tf-field__input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.tf-field--invalid .tf-field__input {
  border-color: #ef4444 !important;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.15);
}

.tf-field__hint {
  font-size: 12px;
  opacity: 0.7;
}

.tf-field__error {
  font-size: 12px;
  color: #ef4444;
  font-weight: 500;
}

/* Submit button */
.tf-submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: var(--technum-teal, #00a896);
  color: var(--technum-white, #ffffff);
  border: none;
  border-radius: 6px;
  padding: 12px 20px;
  font-family: inherit;
  font-weight: 500;
  font-size: var(--btn-size, 14px);
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}

.tf-submit:hover:not(:disabled) {
  background: var(--technum-teal-hover, #008275);
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.tf-submit:disabled { cursor: not-allowed; opacity: 0.7; transform: none; }

.tf-submit--block { width: 100%; }

.tf-submit__spinner {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  animation: tf-spin 0.8s linear infinite;
}

@keyframes tf-spin { to { transform: rotate(360deg); } }

/* Status messages */
.tf-status {
  border-radius: 6px;
  padding: 10px 12px;
  font-size: 13px;
  line-height: 1.4;
}

.tf-status--success {
  background: rgba(16, 185, 129, 0.12);
  color: #10b981;
  border: 1px solid rgba(16, 185, 129, 0.35);
}

.tf-status--error {
  background: rgba(239, 68, 68, 0.12);
  color: #fca5a5;
  border: 1px solid rgba(239, 68, 68, 0.35);
}

/* Checkbox */
.tf-checkbox { display: flex; flex-direction: column; gap: 4px; }
.tf-checkbox__row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  cursor: pointer;
  font-size: 13px;
  line-height: 1.5;
  -webkit-user-select: none;
          user-select: none;
}
.tf-checkbox__input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.tf-checkbox__box {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 1.5px solid currentColor;
  background: transparent;
  margin-top: 1px;
  position: relative;
  transition: background 0.2s ease, border-color 0.2s ease;
}
.tf-checkbox__input:checked + .tf-checkbox__box {
  background: var(--technum-teal, #00a896);
  border-color: var(--technum-teal, #00a896);
}
.tf-checkbox__input:checked + .tf-checkbox__box::after {
  content: '';
  position: absolute;
  left: 5px;
  top: 1px;
  width: 5px;
  height: 10px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.tf-checkbox__input:focus-visible + .tf-checkbox__box {
  outline: 2px solid var(--technum-teal, #00a896);
  outline-offset: 2px;
}
.tf-checkbox--invalid .tf-checkbox__box { border-color: #ef4444; }
.tf-checkbox__label { flex: 1 1; }

/* File upload */
.tf-file { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }
.tf-file__input { position: absolute; opacity: 0; width: 1px; height: 1px; pointer-events: none; }
.tf-file__btn {
  flex-shrink: 0;
  border-radius: 6px;
  padding: 8px 14px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;
}
.tf-file__btn:disabled { cursor: not-allowed; opacity: 0.6; }
.tf-file__name { font-size: 13px; opacity: 0.8; word-break: break-all; min-width: 0; }

/* ───── Dark variant (on dark backgrounds, e.g. Footer) ───── */
.tf-form--dark .tf-field__label { color: rgba(255, 255, 255, 0.85); }

.tf-form--dark .tf-field__input {
  background-color: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: var(--technum-white, #ffffff);
}

.tf-form--dark .tf-field__input::placeholder {
  color: rgba(255, 255, 255, 0.45);
}

.tf-form--dark .tf-field__input:hover:not(:disabled) {
  border-color: rgba(255, 255, 255, 0.22);
}

.tf-form--dark .tf-field__input:focus {
  outline: none;
  border-color: var(--technum-teal, #00a896);
  background-color: rgba(255, 255, 255, 0.08);
  box-shadow: 0 0 0 3px rgba(0, 168, 150, 0.25);
}

.tf-form--dark .tf-field__input--select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.tf-form--dark .tf-field__input--select option {
  background: var(--technum-navy, #0a1628);
  color: var(--technum-white, #ffffff);
}

.tf-form--dark .tf-field__hint { color: rgba(255, 255, 255, 0.55); }

.tf-form--dark .tf-checkbox__row { color: rgba(255, 255, 255, 0.85); }
.tf-form--dark .tf-checkbox__box { border-color: rgba(255, 255, 255, 0.4); }

.tf-form--dark .tf-file__btn {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.18);
  color: var(--technum-white, #fff);
}
.tf-form--dark .tf-file__btn:hover:not(:disabled) {
  border-color: var(--technum-teal, #00a896);
  background: rgba(255, 255, 255, 0.08);
}
.tf-form--dark .tf-file__name { color: rgba(255, 255, 255, 0.65); }

/* ───── Light variant (on light cards, e.g. Contact page) ───── */
.tf-form--light .tf-field__label { color: #1f2937; }

.tf-form--light .tf-field__input {
  background-color: #ffffff;
  border: 1px solid #d1d5db;
  color: #111827;
}

.tf-form--light .tf-field__input::placeholder {
  color: #9ca3af;
}

.tf-form--light .tf-field__input:hover:not(:disabled) {
  border-color: #9ca3af;
}

.tf-form--light .tf-field__input:focus {
  outline: none;
  border-color: var(--technum-teal, #00a896);
  background-color: #ffffff;
  box-shadow: 0 0 0 3px rgba(0, 168, 150, 0.18);
}

.tf-form--light .tf-field__input--select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.tf-form--light .tf-field__hint { color: #6b7280; }

.tf-form--light .tf-checkbox__row { color: #374151; }
.tf-form--light .tf-checkbox__box { border-color: #9ca3af; }

.tf-form--light .tf-file__btn {
  background: #ffffff;
  border: 1px solid #d1d5db;
  color: #111827;
}
.tf-form--light .tf-file__btn:hover:not(:disabled) {
  border-color: var(--technum-teal, #00a896);
  background: #f9fafb;
}
.tf-form--light .tf-file__name { color: #4b5563; }

/* ───── Compact variant (tight spaces, e.g. footer) ───── */
.tf-form--compact { gap: 10px; }
.tf-form--compact .tf-field__input { padding: 9px 12px; font-size: 13px; }
.tf-form--compact .tf-field__input--textarea { min-height: 72px; }
.tf-form--compact .tf-submit { padding: 10px 16px; }

@media (max-width: 768px) {
  .tf-form--compact .tf-field__input { padding: 8px 10px; }
  .tf-form--compact .tf-field__input--textarea { min-height: 60px; }
  .tf-form--compact .tf-submit { padding: 9px 14px; }
}

@media (max-width: 480px) {
  .tf-form { gap: 10px; }
  .tf-form--compact .tf-field__input { padding: 7px 9px; border-radius: 5px; }
  .tf-form--compact .tf-field__input--textarea { min-height: 52px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Forms/Forms.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,+EAA+E;AACjF;;AAEA;;;;CAIC;AACD;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,2BAA2B;EAC3B,qBAAqB;EACrB,+BAA+B;EAC/B,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gBAAgB,0BAA0B,EAAE;AAC9C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;EAChB,8EAA8E;EAC9E,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,wCAAwC;EACxC,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,2EAA2E;AAC7E;;AAEA;EACE,8CAA8C;EAC9C,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,sBAAsB,mBAAmB,EAAE,YAAY,EAAE,eAAe,EAAE;;AAE1E,oBAAoB,WAAW,EAAE;;AAEjC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA,qBAAqB,KAAK,yBAAyB,EAAE,EAAE;;AAEvD,oBAAoB;AACpB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA,aAAa;AACb,eAAe,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAChE;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,wDAAwD;AAC1D;AACA;EACE,wCAAwC;EACxC,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,+CAA+C;EAC/C,mBAAmB;AACrB;AACA,0CAA0C,qBAAqB,EAAE;AACjE,sBAAsB,SAAO,EAAE;;AAE/B,gBAAgB;AAChB,WAAW,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE;AAC3E,kBAAkB,kBAAkB,EAAE,UAAU,EAAE,UAAU,EAAE,WAAW,EAAE,oBAAoB,EAAE;AACjG;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wDAAwD;AAC1D;AACA,yBAAyB,mBAAmB,EAAE,YAAY,EAAE;AAC5D,iBAAiB,eAAe,EAAE,YAAY,EAAE,qBAAqB,EAAE,YAAY,EAAE;;AAErF,gEAAgE;AAChE,kCAAkC,gCAAgC,EAAE;;AAEpE;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,2CAA2C;EAC3C,6CAA6C;AAC/C;;AAEA;EACE,yDAA4R;AAC9R;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA,iCAAiC,gCAAgC,EAAE;;AAEnE,mCAAmC,gCAAgC,EAAE;AACrE,mCAAmC,sCAAsC,EAAE;;AAE3E;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,iCAAiC;AACnC;AACA;EACE,0CAA0C;EAC1C,qCAAqC;AACvC;AACA,gCAAgC,gCAAgC,EAAE;;AAElE,kEAAkE;AAClE,mCAAmC,cAAc,EAAE;;AAEnD;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,yDAA4R;AAC9R;;AAEA,kCAAkC,cAAc,EAAE;;AAElD,oCAAoC,cAAc,EAAE;AACpD,oCAAoC,qBAAqB,EAAE;;AAE3D;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;AACA,iCAAiC,cAAc,EAAE;;AAEjD,4DAA4D;AAC5D,oBAAoB,SAAS,EAAE;AAC/B,qCAAqC,iBAAiB,EAAE,eAAe,EAAE;AACzE,+CAA+C,gBAAgB,EAAE;AACjE,+BAA+B,kBAAkB,EAAE;;AAEnD;EACE,qCAAqC,iBAAiB,EAAE;EACxD,+CAA+C,gBAAgB,EAAE;EACjE,+BAA+B,iBAAiB,EAAE;AACpD;;AAEA;EACE,WAAW,SAAS,EAAE;EACtB,qCAAqC,gBAAgB,EAAE,kBAAkB,EAAE;EAC3E,+CAA+C,gBAAgB,EAAE;AACnE","sourcesContent":[".tf-form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n/*\n  Invisible honeypot field. Rendered next to every SubmitButton.\n  Real users can't see, focus, or tab to it. Bots that crawl the DOM\n  fill every input and trip the silent reject in useContactForm.\n*/\n.tf-honeypot {\n  position: absolute !important;\n  left: -10000px !important;\n  top: auto !important;\n  width: 1px !important;\n  height: 1px !important;\n  overflow: hidden !important;\n  opacity: 0 !important;\n  pointer-events: none !important;\n  border: 0 !important;\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n.tf-form__row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n@media (max-width: 600px) {\n  .tf-form__row { grid-template-columns: 1fr; }\n}\n\n.tf-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.tf-field__label {\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.3;\n  color: inherit;\n}\n\n.tf-field__required {\n  color: var(--technum-teal, #00a896);\n  margin-left: 2px;\n}\n\n.tf-field__input {\n  width: 100%;\n  border-radius: 6px;\n  padding: 10px 14px;\n  font-family: inherit;\n  font-size: var(--body-regular, 14px);\n  line-height: 1.4;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;\n  appearance: none;\n  box-sizing: border-box;\n}\n\n.tf-field__input--select {\n  cursor: pointer;\n  padding-right: 36px;\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  background-size: 12px;\n}\n\n.tf-field__input--textarea {\n  resize: vertical;\n  min-height: 88px;\n}\n\n.tf-field__input:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.tf-field--invalid .tf-field__input {\n  border-color: #ef4444 !important;\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.15);\n}\n\n.tf-field__hint {\n  font-size: 12px;\n  opacity: 0.7;\n}\n\n.tf-field__error {\n  font-size: 12px;\n  color: #ef4444;\n  font-weight: 500;\n}\n\n/* Submit button */\n.tf-submit {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: var(--technum-teal, #00a896);\n  color: var(--technum-white, #ffffff);\n  border: none;\n  border-radius: 6px;\n  padding: 12px 20px;\n  font-family: inherit;\n  font-weight: 500;\n  font-size: var(--btn-size, 14px);\n  cursor: pointer;\n  transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.tf-submit:hover:not(:disabled) {\n  background: var(--technum-teal-hover, #008275);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n}\n\n.tf-submit:disabled { cursor: not-allowed; opacity: 0.7; transform: none; }\n\n.tf-submit--block { width: 100%; }\n\n.tf-submit__spinner {\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  border: 2px solid rgba(255, 255, 255, 0.4);\n  border-top-color: #fff;\n  animation: tf-spin 0.8s linear infinite;\n}\n\n@keyframes tf-spin { to { transform: rotate(360deg); } }\n\n/* Status messages */\n.tf-status {\n  border-radius: 6px;\n  padding: 10px 12px;\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n.tf-status--success {\n  background: rgba(16, 185, 129, 0.12);\n  color: #10b981;\n  border: 1px solid rgba(16, 185, 129, 0.35);\n}\n\n.tf-status--error {\n  background: rgba(239, 68, 68, 0.12);\n  color: #fca5a5;\n  border: 1px solid rgba(239, 68, 68, 0.35);\n}\n\n/* Checkbox */\n.tf-checkbox { display: flex; flex-direction: column; gap: 4px; }\n.tf-checkbox__row {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  cursor: pointer;\n  font-size: 13px;\n  line-height: 1.5;\n  user-select: none;\n}\n.tf-checkbox__input {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n.tf-checkbox__box {\n  flex-shrink: 0;\n  width: 18px;\n  height: 18px;\n  border-radius: 4px;\n  border: 1.5px solid currentColor;\n  background: transparent;\n  margin-top: 1px;\n  position: relative;\n  transition: background 0.2s ease, border-color 0.2s ease;\n}\n.tf-checkbox__input:checked + .tf-checkbox__box {\n  background: var(--technum-teal, #00a896);\n  border-color: var(--technum-teal, #00a896);\n}\n.tf-checkbox__input:checked + .tf-checkbox__box::after {\n  content: '';\n  position: absolute;\n  left: 5px;\n  top: 1px;\n  width: 5px;\n  height: 10px;\n  border: solid #fff;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n.tf-checkbox__input:focus-visible + .tf-checkbox__box {\n  outline: 2px solid var(--technum-teal, #00a896);\n  outline-offset: 2px;\n}\n.tf-checkbox--invalid .tf-checkbox__box { border-color: #ef4444; }\n.tf-checkbox__label { flex: 1; }\n\n/* File upload */\n.tf-file { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }\n.tf-file__input { position: absolute; opacity: 0; width: 1px; height: 1px; pointer-events: none; }\n.tf-file__btn {\n  flex-shrink: 0;\n  border-radius: 6px;\n  padding: 8px 14px;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s ease, border-color 0.2s ease;\n}\n.tf-file__btn:disabled { cursor: not-allowed; opacity: 0.6; }\n.tf-file__name { font-size: 13px; opacity: 0.8; word-break: break-all; min-width: 0; }\n\n/* ───── Dark variant (on dark backgrounds, e.g. Footer) ───── */\n.tf-form--dark .tf-field__label { color: rgba(255, 255, 255, 0.85); }\n\n.tf-form--dark .tf-field__input {\n  background-color: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  color: var(--technum-white, #ffffff);\n}\n\n.tf-form--dark .tf-field__input::placeholder {\n  color: rgba(255, 255, 255, 0.45);\n}\n\n.tf-form--dark .tf-field__input:hover:not(:disabled) {\n  border-color: rgba(255, 255, 255, 0.22);\n}\n\n.tf-form--dark .tf-field__input:focus {\n  outline: none;\n  border-color: var(--technum-teal, #00a896);\n  background-color: rgba(255, 255, 255, 0.08);\n  box-shadow: 0 0 0 3px rgba(0, 168, 150, 0.25);\n}\n\n.tf-form--dark .tf-field__input--select {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%23FFFFFF' viewBox='0 0 16 16'%3E%3Cpath d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/%3E%3C/svg%3E\");\n}\n\n.tf-form--dark .tf-field__input--select option {\n  background: var(--technum-navy, #0a1628);\n  color: var(--technum-white, #ffffff);\n}\n\n.tf-form--dark .tf-field__hint { color: rgba(255, 255, 255, 0.55); }\n\n.tf-form--dark .tf-checkbox__row { color: rgba(255, 255, 255, 0.85); }\n.tf-form--dark .tf-checkbox__box { border-color: rgba(255, 255, 255, 0.4); }\n\n.tf-form--dark .tf-file__btn {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  color: var(--technum-white, #fff);\n}\n.tf-form--dark .tf-file__btn:hover:not(:disabled) {\n  border-color: var(--technum-teal, #00a896);\n  background: rgba(255, 255, 255, 0.08);\n}\n.tf-form--dark .tf-file__name { color: rgba(255, 255, 255, 0.65); }\n\n/* ───── Light variant (on light cards, e.g. Contact page) ───── */\n.tf-form--light .tf-field__label { color: #1f2937; }\n\n.tf-form--light .tf-field__input {\n  background-color: #ffffff;\n  border: 1px solid #d1d5db;\n  color: #111827;\n}\n\n.tf-form--light .tf-field__input::placeholder {\n  color: #9ca3af;\n}\n\n.tf-form--light .tf-field__input:hover:not(:disabled) {\n  border-color: #9ca3af;\n}\n\n.tf-form--light .tf-field__input:focus {\n  outline: none;\n  border-color: var(--technum-teal, #00a896);\n  background-color: #ffffff;\n  box-shadow: 0 0 0 3px rgba(0, 168, 150, 0.18);\n}\n\n.tf-form--light .tf-field__input--select {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%23374151' viewBox='0 0 16 16'%3E%3Cpath d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/%3E%3C/svg%3E\");\n}\n\n.tf-form--light .tf-field__hint { color: #6b7280; }\n\n.tf-form--light .tf-checkbox__row { color: #374151; }\n.tf-form--light .tf-checkbox__box { border-color: #9ca3af; }\n\n.tf-form--light .tf-file__btn {\n  background: #ffffff;\n  border: 1px solid #d1d5db;\n  color: #111827;\n}\n.tf-form--light .tf-file__btn:hover:not(:disabled) {\n  border-color: var(--technum-teal, #00a896);\n  background: #f9fafb;\n}\n.tf-form--light .tf-file__name { color: #4b5563; }\n\n/* ───── Compact variant (tight spaces, e.g. footer) ───── */\n.tf-form--compact { gap: 10px; }\n.tf-form--compact .tf-field__input { padding: 9px 12px; font-size: 13px; }\n.tf-form--compact .tf-field__input--textarea { min-height: 72px; }\n.tf-form--compact .tf-submit { padding: 10px 16px; }\n\n@media (max-width: 768px) {\n  .tf-form--compact .tf-field__input { padding: 8px 10px; }\n  .tf-form--compact .tf-field__input--textarea { min-height: 60px; }\n  .tf-form--compact .tf-submit { padding: 9px 14px; }\n}\n\n@media (max-width: 480px) {\n  .tf-form { gap: 10px; }\n  .tf-form--compact .tf-field__input { padding: 7px 9px; border-radius: 5px; }\n  .tf-form--compact .tf-field__input--textarea { min-height: 52px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
